// @flow

import { reduce } from '../../network/reduce';
import type { ApolloConfiguration, ModalElements } from '../../types/commonTypes';

export const OPEN_KEEPEEK_MODAL = 'OPEN_KEEPEEK_MODAL';
export const IS_MEDIA_LOADING = 'IS_MEDIA_LOADING';
export const APOLLO_CONFIGURATION = 'APOLLO_CONFIGURATION';
export const SAVE_DISABLED_NO_DATA = 'SAVE_DISABLED_NO_DATA';

type pageStateType = {
  openModal: ModalElements,
  apolloConfiguration: ?ApolloConfiguration,
  isMediaLoading: boolean,
  +disabledNoDataTabs: string[],
};

export const initialState: pageStateType = {
  openModal: {
    medias: [],
    itemSelected: 0,
    isOpen: false,
    isAlreadyLoaded: false,
  },
  isMediaLoading: true,
  apolloConfiguration: null,
  disabledNoDataTabs: [],
};

const pageReducer = reduce(initialState, {
  [OPEN_KEEPEEK_MODAL]: 'openModal',
  [IS_MEDIA_LOADING]: 'isMediaLoading',
  [APOLLO_CONFIGURATION]: 'apolloConfiguration',
  [SAVE_DISABLED_NO_DATA]: 'disabledNoDataTabs',
});

export default pageReducer;
